document.addEventListener('DOMContentLoaded', () => {
  const nav = document.querySelector('.header-megalinks');
  const parents = Array.from(document.querySelectorAll('.header-megalinks-parent'));
  const hoverMql = window.matchMedia('(hover: hover) and (pointer: fine)');

  if (!nav) return;

  const getDropdown = (el) => el.querySelector('.header-megalinks-dropdown');

  const open = (wrapper) => {
    parents.forEach(p => {
      if (p !== wrapper) close(p);
    });

    wrapper.setAttribute('aria-expanded', 'true');
    wrapper.classList.add('is-visible');

    const submenu = getDropdown(wrapper);
    if (submenu) submenu.classList.add('is-visible');
  };

  const close = (wrapper) => {
    wrapper.setAttribute('aria-expanded', 'false');
    wrapper.classList.remove('is-visible');

    const submenu = getDropdown(wrapper);
    if (submenu) submenu.classList.remove('is-visible');
  };

  const closeAll = () => parents.forEach(close);

  const bindHover = () => {

    nav.addEventListener('mouseover', (e) => {
      const link = e.target.closest('a.header-megalink');
      if (!link) return;

      const wrapper = link.closest('.header-megalinks-parent');
      if (!wrapper) {
        closeAll();
        return;
      }

      const hasDropdown = wrapper.querySelector('.header-megalinks-dropdown');

      if (hasDropdown) {
        open(wrapper);
      } else {
        // If top-level link has no dropdown → close everything
        closeAll();
      }
    });

    nav.addEventListener('mouseleave', closeAll);
  };

  if (hoverMql.matches) bindHover();

  if (hoverMql.addEventListener) {
    hoverMql.addEventListener('change', (e) => {
      if (!e.matches) closeAll();
    });
  } else {
    hoverMql.addListener((e) => {
      if (!e.matches) closeAll();
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
});